import PropTypes from 'prop-types';
import React from 'react';

import {LinkButton} from 'cstar-react-primitives';
import {FormattedMessage} from 'react-intl';
import {listingFormMessages} from './lineItemMessages';

const DetailsLinkButton = ({ itemId, detailsVisible, setDetailsVisible }) => {
    const detailButtonProps = {
        type: 'button',
        id: itemId,
        onClick: () => setDetailsVisible(!detailsVisible),
        isCentered: false
    };
    return (
        <LinkButton {...detailButtonProps}>
            {detailsVisible ? (
                <FormattedMessage {...listingFormMessages.hideDetailsButtonText} />
            ) : (
                <FormattedMessage {...listingFormMessages.viewDetailsButtonText} />
            )}
        </LinkButton>
    );
};

DetailsLinkButton.propTypes = {
    itemId: PropTypes.string.isRequired,
    detailsVisible: PropTypes.bool.isRequired,
    setDetailsVisible: PropTypes.func.isRequired
};

export default DetailsLinkButton
